<script>
import HeadUser from "@/layout/components/Head-user.vue";
import StorageUtils from "@/utils/storageUtils";

export default {
  name: "Head-sticky",
  components: {HeadUser},
  data() {
    return {
      condition: {
        keywords: null,
      }
    }
  },
  props: {
    hasSearch: {
      type: Boolean,
      default: true
    },
    hasLogin: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    StorageUtils() {
      return StorageUtils
    },
    /** 搜索  */
    handleSearch() {
      this.$emit('handleSearch', this.condition.keywords);
    },
    handleSetClose() {
      this.condition.keywords = '';
    },
    handleKeydown() {
      this.handleSearch();
    },
    handleClickRouter(path) {
      this.$router.push(path);
      this.$emit('handleClickRouter',path);
    }
  }
}
</script>

<template>
  <div class="main-center">
    <div class="layout-head" id="headSticky">
      <div class="layout-head-left">
        <img src="@/assets/image/logo.png" class="layout-head-left-logo" alt="">
        <span class="layout-head-left-title">金誉房屋价值评估系统</span>
      </div>
      <div class="layout-head-right" v-if="hasLogin">
        <span class="cp layout-head-right-but" @click="handleClickRouter('/login')" v-if="!StorageUtils().getItem('token')">登录</span>
        <HeadUser v-else></HeadUser>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;


  &-left {
    display: flex;
    align-items: center;

    &-logo {
      width: 40px;
      height: 40px;
    }

    &-title {
      margin-left: 20px;
      font-size: 20px;
      font-weight: 500;
      color: var(--page-headFontSize);
    }
  }

  &-right {
    box-sizing: border-box;
    color: var(--page-headFontSize);

    ::v-deep .el-input-group__append {
      background-color: $custom-primary-color;
      padding: 0 10px;
    }

    &-but {
      font-size: 20px;
      font-weight: 500;
    }
  }
}
</style>